import { render, staticRenderFns } from "./TasanteaProductDetail.vue?vue&type=template&id=08061760&scoped=true"
import script from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
export * from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./TasanteaProductDetail.vue?vue&type=style&index=0&id=08061760&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08061760",
  null
  
)

export default component.exports